const ve = {
    CustomEvent: "ce",
    Pr: "p",
    Ol: "pc",
    cc: "ca",
    Aa: "i",
    qs: "ie",
    T: "cci",
    W: "ccic",
    _: "ccc",
    L: "ccd",
    yh: "ss",
    wh: "se",
    Mi: "si",
    Ii: "sc",
    Ai: "sbc",
    Ze: "sfe",
    ro: "iec",
    Nl: "lr",
    Ml: "uae",
    U: "ci",
    F: "cc",
    xl: "lcaa",
    Ul: "lcar",
    Fn: "inc",
    Un: "add",
    En: "rem",
    Sn: "set",
    An: "ncam",
    Jl: "sgu"
  },
  De = { qr: "feed_displayed", dc: "content_cards_displayed" };
export { ve as EventTypes, De as InternalEventTypes };
